'use client';

import React from 'react';
import { TasticProps } from '../types';
import TextOnlyBanner, {Props} from 'components/commercetools-ui/organisms/text-only-banner';

const TextOnlyBannerTastic = ({ data }: TasticProps<Props>) => {

  return (
    <TextOnlyBanner data={data} />
  );
};

export default TextOnlyBannerTastic;
